<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsPaperlessPromoTitle')" [showCloseButton]="false">
    <div modal-content>
      <p id="paperless-promo-modal-message" class="font-dm text-sm text-ld-neutral-500 text-center mb-4">
        {{ t('modalsPaperlessPromoMessage') }}
      </p>

      @if (userEmail()) {
        <div class="bg-ld-neutral-50 rounded-lg p-3 mb-4">
          <p class="text-xs text-ld-neutral-500 mb-1">{{ t('modalsPaperlessPromoDocumentsSentTo') }}</p>
          <p class="text-sm font-medium text-ld-neutral">{{ userEmail() }}</p>
        </div>
      }

      <div
        id="paperless-promo-modal-disclosure"
        class="bg-ld-neutral-50 rounded-lg p-4 text-xs text-ld-neutral-500 max-h-40 overflow-y-auto"
      >
        <p class="font-semibold text-ld-neutral mb-2">{{ t('commonTcpaEconsentDisclosureTitle') }}</p>
        <p class="mb-2">
          {{ t('modalsPaperlessPromoDisclosureIntro') }}
        </p>
        <ul class="list-disc pl-4 mb-2 space-y-1">
          <li>{{ t('modalsPaperlessPromoBillingStatements') }}</li>
          <li>{{ t('modalsPaperlessPromoTaxDocuments') }}</li>
          <li>{{ t('modalsPaperlessPromoEscrowStatements') }}</li>
          <li>{{ t('modalsPaperlessPromoOtherCorrespondence') }}</li>
        </ul>
        <p>
          {{ t('modalsPaperlessPromoWithdrawConsent') }}
        </p>
      </div>
    </div>
    <div modal-footer>
      <button
        id="paperless-promo-modal-accept-btn"
        type="button"
        class="btn-primary-ld-purple order-2! w-full! py-3 px-6 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isLoading()"
        (click)="onAccept()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4!"></mat-spinner>
        }
        <mat-icon class="text-lg!">eco</mat-icon>
        {{ t('goPaperlessTitle') }}
      </button>

      <button
        id="paperless-promo-modal-decline-btn"
        type="button"
        class="btn-outline-ld-purple order-1! w-full! py-3 px-6 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isLoading()"
        (click)="onDecline()"
      >
        {{ t('modalsPaperlessPromoKeepPaper') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
